/**
 * Ramp — Phase 3. Slope-constrained run: the rise and the type's max slope determine
 * the REQUIRED run length (rise ÷ slope); the drawn `path` is the walking centerline
 * and the ramp continues along the last segment if drawn short (same convention as
 * stairs). Default max slope 1:12.
 */
import type { CategorySchema } from '../../registry'

export const rampSchema: CategorySchema = {
  id: 'ramp',
  pathParamKey: 'path',
  label: 'Ramp',
  typeParams: {
    groups: [
      {
        label: 'Appearance',
        params: [
          // P6b: '' = the built-in default look (pre-P6b behavior)
          { key: 'surfaceMaterial', label: 'Material', kind: 'material', default: '' },
        ],
      },
      {
        label: 'Calculator',
        params: [
          { key: 'maxSlopeRatio', label: 'Max Slope (rise per ft of run)', kind: 'number', default: 1 / 12, min: 0.01, max: 0.5 },
          { key: 'slabThicknessFt', label: 'Slab Thickness', kind: 'length', default: 4 / 12, min: 1 / 12, max: 2 },
        ],
      },
    ],
  },
  instanceParams: {
    groups: [
      {
        label: 'Constraints',
        params: [
          { key: 'path', label: 'Run', kind: 'path2d', default: null },
          { key: 'widthFt', label: 'Width', kind: 'length', default: 4, min: 2.5, max: 12 },
          { key: 'riseFt', label: 'Rise', kind: 'length', default: 2, min: 0.1, max: 20 },
          { key: 'baseOffsetFt', label: 'Base Offset', kind: 'length', default: 0, min: -20, max: 20 },
        ],
      },
    ],
  },
}
